<template>
  <div v-if="input">
    <Dialog
      :visible.sync="active"
      :modal="true"
      :closable="false"
      :style="{ maxWidth: '90%', width: 'auto', minWidth: '450px' }"
    >
      <template #header>
        <h2 class="title is-5 w100">
          {{ $t("manage-scoring-system") }}
          <font-awesome-icon
            class="menuIcon floatRight cursorpointer ml-5"
            :icon="['fal', 'times-circle']"
            @click="close"
          />
        </h2>
      </template>

      <div>
        <div class="p-d-flex p-justify-between mb-3">
          <span class="p-as-center">{{ $t("win") }}</span>
          <InputText v-model="input.win_points" @keypress="isNumber"></InputText>
        </div>

        <div class="p-d-flex p-justify-between mb-3">
          <span class="p-as-center">{{ $t("loss") }}</span>
          <InputText v-model="input.loss_points" @keypress="isNumber"></InputText>
        </div>

        <div class="p-d-flex p-justify-between mb-3">
          <span class="p-as-center">{{ $t("tie") }}</span>
          <InputText v-model="input.tie_points" @keypress="isNumber"></InputText>
        </div>

        <div class="p-d-flex p-justify-between mb-3">
          <span class="p-as-center">{{ $t("overtime-win") }}</span>
          <InputText v-model="input.overtime_win_points" @keypress="isNumber"></InputText>
        </div>

        <div class="p-d-flex p-justify-between mb-3">
          <span class="p-as-center">{{ $t("overtime-loss") }}</span>
          <InputText v-model="input.overtime_loss_points" @keypress="isNumber"></InputText>
        </div>

        <div class="p-text-center mt-5">
          <Button @click="this.saveCallback">{{ $t("recalculate") }}</Button>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script>
export default {
  props: {
    input: {
      type: Object,
      required: false,
    },
    active: {
      type: Boolean,
      required: true,
    },
    close: {
      type: Function,
      required: true,
    },
    updateScoringSystemValues: {
      type: Function,
      required: true,
    },
  },
  methods: {
    saveCallback() {
      this.updateScoringSystemValues(this.input);
      this.close();
    },
  },
};
</script>

<style scoped lang="scss"></style>
